import { ndash } from '@ipfabric/frontend-shared-assets/utils/characters';
import { PageLayout } from '@ipfabric/ui-components/PageLayout/PageLayout';
import { ScrollView } from '@ipfabric/ui-components/ScrollView/ScrollView';
import { useQuery } from '@tanstack/react-query';
import { Button } from 'components/Button/Button';
import { Diff } from 'components/Diff/Diff';
import { ModalFullContent } from 'components/ModalFullContent/ModalFullContent';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import { renderQuery } from 'utils/react-query/renderQuery';
import { useApi } from 'utils/request/useApi';

type Props = {
  // false positive, used for Diff component

  hostname: string;
  blobKey: string;
  onClose: () => void;
};

export const SavedConfigConsistencyDiffModal: FC<Props> = (props) => {
  const diffMsg = useLocale().managementSavedConfigConsistency.diff;

  const api = useApi();
  const diff = useQuery(
    api.cachedQuery({
      method: 'GET',
      url: `/blobs/device-configuration/${props.blobKey}`,
    }),
  );

  return (
    <ModalFullContent>
      <ScrollView contentClassName='flex flex-col'>
        <PageLayout noPadding className='flex flex-col gap-4 p'>
          <div>
            <Button
              type='button'
              variant='secondary'
              icon='fa-angle-left'
              size='sm'
              onClick={props.onClose}
            >
              {diffMsg.backButton}
            </Button>
          </div>
          {renderQuery({
            query: diff,
            renderStaleDataOnMount: false,
            success: (data) => (
              <Diff
                content={[
                  {
                    text: data.startupConfig,
                  },
                  {
                    text: data.currentConfig,
                  },
                ]}
                title={
                  <>
                    <strong>{props.hostname}</strong>
                    {` ${ndash} ${diffMsg.title}`}
                  </>
                }
              />
            ),
          })}
        </PageLayout>
      </ScrollView>
    </ModalFullContent>
  );
};
